import apiClient from './apiClient';

/**
 * Cache für Tenant-Branding-Daten mit Time-to-Live
 * Reduziert unnötige API-Aufrufe für statische Branding-Informationen
 */
const brandingCache = new Map();
const CACHE_TTL_MS = 30 * 60 * 1000; // 30 Minuten Cache-Laufzeit

const tenantService = {
  /**
   * Lädt Branding-Informationen für einen Tenant
   * @param {string} tenantSlug - Der Tenant-Identifier
   * @returns {Promise<{slug: string, name: string, logoUrl: string|null}>}
   */
  getBranding: async (tenantSlug) => {
    // Prüfe Cache zuerst
    const cached = brandingCache.get(tenantSlug);
    if (cached && Date.now() - cached.timestamp < CACHE_TTL_MS) {
      return cached.data;
    }

    // API-Aufruf durchführen (ohne JWT - public endpoint)
    const response = await apiClient.get(`/tenants/${tenantSlug}/branding`);
    const data = response.data;

    // Cache aktualisieren
    brandingCache.set(tenantSlug, {
      data,
      timestamp: Date.now()
    });

    return data;
  },

  /**
   * Löscht den kompletten Branding-Cache
   * Nützlich nach Login/Logout
   */
  clearCache: () => {
    brandingCache.clear();
  },

  /**
   * Löscht den Cache für einen spezifischen Tenant
   * Nützlich bei Tenant-Wechsel
   * @param {string} tenantSlug - Der Tenant-Identifier
   */
  clearCacheForSlug: (tenantSlug) => {
    if (tenantSlug) {
      brandingCache.delete(tenantSlug);
    }
  }
};

export default tenantService;
